export default (value) => value.replace(/\s/g, '');
